import React from "react";

import Table from "../../common/Table";
import Option from "../../common/RowOption";

import { Link } from "react-router-dom";

const ExpenseSubAccountsList = ({ data, match, query, halfYear }) => {
  const { tid, aid } = match.params;

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "budget_code",
      label: "کد بودجه",
    },
    {
      path: "name",
      label: "نام",
      content: (e) => (
        <Link
          to={`/mis/expenses/types/${tid}/accounts/${aid}/subAccounts/${e.id}/expenses`}
        >
          {e.name}
        </Link>
      ),
    },
    {
      path: "budget",
      label: "بودجه",
    },
    { path: "paid", label: "پرداخت شده" },
    {
      path: "balance",
      label: "باقیمانده",
    },
    {
      path: "option",
      content: (e) => (
        <Option
          Edit={{
            form: "expense-sub-account-form",
            cache: e.id,
            edit: e,
            type: aid,
          }}
          Delete={{ route: "expenses/subAccounts", id: e.id }}
          Print={
            halfYear
              ? {
                  route: `expenses/type/${tid}/account/${aid}/subAccount/${e.id}/halfYear/${halfYear}`,
                  title: "چاپ",
                }
              : undefined
          }
        />
      ),
    },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default ExpenseSubAccountsList;
